import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /app has no page of its own: open the retailer the session last used, or
 * the first one this person belongs to.
 */
export const Route = createFileRoute("/_saas/app/_account/")({
	beforeLoad: ({ context }) => {
		const { session, organizations } = context;
		const organization =
			organizations?.find(
				(org) => org.id === session.session.activeOrganizationId,
			) ?? organizations?.[0];

		if (!organization) {
			// Platform staff can have no retailer of their own.
			throw redirect({
				to:
					session.user.role === "admin"
						? "/app/platform"
						: "/new-organization",
			});
		}

		throw redirect({
			to: "/app/$organizationSlug",
			params: { organizationSlug: organization.slug },
		});
	},
});
